export function mixerPathForHost(hostname) {
  const host = hostname.toLowerCase().replace(/:\d+$/, '');
  if (host === 'overwatchpixelmixer.setup-coding.de') return '/overwatchpixelmixer';
  if (host === 'overwatchcutemixer.setup-coding.de') return '/overwatchcutemixer';
  return null;
}
